export function registerMenuItem(icon, route) {
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return {
    type: 'REGISTER_MENU_ITEM',
    payload: {
      icon: icon,
      route: route,
      label: label
    }
  };
}
export function clearMenuItems() {
  return {
    type: 'CLEAR_MENU_ITEMS'
  };
}